import { StyleSheet } from 'react-native';
export var getEngagementRailWidgetStyles = () => {
  return StyleSheet.create({
    container: {
      display: 'flex',
      width: '100%',
      flex: 1
    }
  });
};